export default __webpack_public_path__ + "static/media/1 (12).e3c103be.jpg";